import React, { useState, useEffect } from 'react';
import AppSettingServices from '../services/AppSettingServices';
import useAsync from '../hooks/useAsync';

function AppGSetting() {
    const { data, error, isLoading } = useAsync(AppSettingServices.getAppSettingDetail);
    
    const [formValues, setFormValues] = useState({
        description: '',
        min_withdraw: 0,
        general_ticket_discount:0,
        max_withdraw: 0,
        ticket_discount:0,
       
    });
useEffect(() => {
    if (data?.data) {
        setFormValues({
            description: data.data.description || '',
            min_withdraw: data.data.min_withdraw || 0,
            max_withdraw: data.data.max_withdraw || 0,
            ticket_discount: data.data.ticket_discount || 0,
            general_ticket_discount: data.data.general_ticket_discount || 0,
        });
    }
}, [data]);


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues({
            ...formValues,
            [name]: value
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        try {
            await AppSettingServices.updateAppSettingDetail(data.data._id, formValues);
            alert('App settings updated successfully');
        } catch (error) {
            console.error('Failed to update app settings', error);
            alert('Failed to update app settings');
        }
    };


    if (isLoading) {
        return <div className="loader design_loading">Loading...</div>;
    }

    if (error) {
        return <div>Error loading contact details</div>;
    }

    return (
        <div className="right_col" role="main">

                 <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">
            
                      <div className="my-auto">
            
                        <h5 className="page-title fs-21 mb-1">
                        App Text Change                     </h5>
                        <nav>
            
                          <ol className="breadcrumb mb-0">
            
                            <li className="breadcrumb-item">
                              <a href="javascript:void(0);">Home</a>
                            </li>
                            <li className="breadcrumb-item active" aria-current="page">
                            App Text
                            </li>
                          </ol>
                        </nav>
                      </div>
                      <div className="d-flex my-xl-auto gap-2 right-content align-items-center">
                        
            
            
            
                      </div>
                    </div>
           
            <div className="container-box">
                <div className="container-box-inner table-reponsive-tabe">
                    <div className="page-details appchangedetails">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                {/* <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label>App Home Screen Footer</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <textarea
                                                type="text"
                                                name="description"
                                                className="form-control"
                                                value={formValues.description}
                                                onChange={handleInputChange}
                                                rows={2}
                                                cols={10}
                                              
                                                maxLength={100}
                                            />
                                        </div>
                                    </div>
                                </div> */}

                                <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label> Minimum  Withdraw</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <input
                                                type="number"
                                                name="min_withdraw"
                                                className="form-control"
                                                value={formValues.min_withdraw}
                                                onChange={handleInputChange}
                                               
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label>Maximume Withdraw</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <input
                                                type="number"
                                                name="max_withdraw"
                                                className="form-control"
                                                value={formValues.max_withdraw}
                                                onChange={handleInputChange}
                                            
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label>Ticket Discount</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <input
                                                type="number"
                                                name="ticket_discount"
                                                className="form-control"
                                                value={formValues.ticket_discount}
                                                onChange={handleInputChange}
                                            
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="input-field1">
                                        <label> General Ticket Discount</label>
                                        <div className="input-link-outer inputpadingnone">
                                            <input
                                                type="number"
                                                name="general_ticket_discount"
                                                className="form-control"
                                                value={formValues.general_ticket_discount}
                                                onChange={handleInputChange}
                                            
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <button type="submit" className="submit-green-btn1 ss-tt">SUBMIT</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AppGSetting;
